var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_c('b-modal', {
    attrs: {
      "title": "Modal Filter",
      "ok-title": "Apply Filter"
    },
    on: {
      "ok": function ok($event) {
        return _vm.fetchData();
      }
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('b-button', {
          attrs: {
            "variant": "outline-secondary"
          },
          on: {
            "click": _vm.resetFilter
          }
        }, [_c('i', {
          staticClass: "fas fa-undo mr-2"
        }), _vm._v(" Reset Filter ")]), _c('b-button', {
          attrs: {
            "variant": "secondary"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v("Cancel")]), _c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              return ok();
            }
          }
        }, [_vm._v("Apply Filter")])];
      }
    }]),
    model: {
      value: _vm.showModalFilter,
      callback: function callback($$v) {
        _vm.showModalFilter = $$v;
      },
      expression: "showModalFilter"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Category",
      "label-for": "equipment-category",
      "label-cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "maintenance_component_id",
      "multiple": "",
      "placeholder": "Select Equipment Category",
      "label": "component_name",
      "options": _vm.categoryOpt,
      "reduce": function reduce(opt) {
        return opt.id;
      }
    },
    model: {
      value: _vm.equipment.params.maintenance_component_id,
      callback: function callback($$v) {
        _vm.$set(_vm.equipment.params, "maintenance_component_id", $$v);
      },
      expression: "equipment.params.maintenance_component_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Used For",
      "label-for": "fleet",
      "label-cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "fleet",
      "multiple": "",
      "placeholder": "Select Vehicle Type",
      "label": "name",
      "options": _vm.typeFleet,
      "reduce": function reduce(opt) {
        return opt.code;
      }
    },
    model: {
      value: _vm.equipment.params.vehicleTypeIds,
      callback: function callback($$v) {
        _vm.$set(_vm.equipment.params, "vehicleTypeIds", $$v);
      },
      expression: "equipment.params.vehicleTypeIds"
    }
  })], 1), _c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Status",
      "label-for": "active",
      "label-cols": "3"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "check-button",
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.equipment.params.active,
      callback: function callback($$v) {
        _vm.$set(_vm.equipment.params, "active", $$v);
      },
      expression: "equipment.params.active"
    }
  }, [_vm.equipment.params.active === false ? [_vm._v("No")] : [_vm._v("Yes")]], 2)], 1)], 1), _c('b-modal', {
    attrs: {
      "title": "Import Data",
      "ok-title": "Submit"
    },
    on: {
      "ok": _vm.handleImport
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "text-primary"
        }, [_vm._v("Import Data")]), _c('i', {
          staticClass: "fa fa-times cursor-pointer",
          on: {
            "click": function click($event) {
              _vm.showModalImport = false;
            }
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showModalImport,
      callback: function callback($$v) {
        _vm.showModalImport = $$v;
      },
      expression: "showModalImport"
    }
  }, [[_c('div', {
    staticClass: "flex flex-column align-items-center"
  }, [_c('b-form-file', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": ".xlsx, .xls, .csv"
    },
    model: {
      value: _vm.importFile,
      callback: function callback($$v) {
        _vm.importFile = $$v;
      },
      expression: "importFile"
    }
  }), _c('small', {
    staticClass: "text-black"
  }, [_vm._v("accept: .xlsx, .xls, .csv")])], 1), _c('b-button', {
    staticClass: "mt-3 w-100",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.handleExport
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download Template ")])]], 2), _c('b-col', {
    attrs: {
      "sm": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("Master Equipment")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', {
          staticClass: "d-flex mb-3"
        }, [_c('b-form', {
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return _vm.fetchData.apply(null, arguments);
            }
          }
        }, [_c('b-form-input', {
          staticClass: "mr-2",
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "type": "text",
            "placeholder": "Search..."
          },
          on: {
            "input": _vm.debouncedSearch,
            "keyup": function keyup($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              return _vm.fetchData.apply(null, arguments);
            }
          },
          model: {
            value: _vm.equipment.params.search,
            callback: function callback($$v) {
              _vm.$set(_vm.equipment.params, "search", $$v);
            },
            expression: "equipment.params.search"
          }
        })], 1), _c('div', [_c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "type": "button",
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              _vm.showModalFilter = true;
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-sliders"
        }), _vm._v(" Filter Data ")])], 1)], 1), _c('div', {
          staticClass: "d-flex"
        }, [_c('b-button', {
          staticClass: "d-flex align-items-center mr-2",
          staticStyle: {
            "height": "max-content"
          },
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              _vm.showModalImport = true;
            }
          }
        }, [_c('i', {
          staticClass: "ri-upload-2-line pl-1"
        }), _vm._v(" Import ")]), _c('b-button', {
          staticStyle: {
            "height": "max-content"
          },
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              return _vm.openSidebar();
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus mr-1"
        }), _vm._v(" New Data ")])], 1)]), _c('div', {
          staticClass: "table-responsive"
        }, [_c('table', {
          staticClass: "table table-bordered table-striped"
        }, [_c('thead', {
          staticClass: "thead-light"
        }, [_c('tr', [_c('th', [_vm._v("Equipment Code")]), _c('th', [_vm._v("Equipment Name")]), _c('th', [_vm._v("Category")]), _c('th', {
          staticStyle: {
            "width": "30%"
          }
        }, [_vm._v("Used For")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Status")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Action")])])]), _c('tbody', _vm._l(_vm.equipment.data, function (item, index) {
          var _item$equipment_id, _item$maintenance_com, _item$maintenance_com2;
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v(_vm._s((_item$equipment_id = item.equipment_id) !== null && _item$equipment_id !== void 0 ? _item$equipment_id : '-'))]), _c('td', [_vm._v(_vm._s(item.equipment_name))]), _c('td', [_vm._v(_vm._s((_item$maintenance_com = item.maintenance_component) === null || _item$maintenance_com === void 0 ? void 0 : _item$maintenance_com.component_name))]), _c('td', {
            staticStyle: {
              "width": "30%"
            }
          }, _vm._l((_item$maintenance_com2 = item.maintenance_component) === null || _item$maintenance_com2 === void 0 ? void 0 : _item$maintenance_com2.maintenance_component_vehicle_types, function (type, i) {
            var _type$vehicle_type;
            return _c('span', {
              key: i,
              staticClass: "badge badge-light border mr-1"
            }, [_vm._v(" " + _vm._s(type === null || type === void 0 ? void 0 : (_type$vehicle_type = type.vehicle_type) === null || _type$vehicle_type === void 0 ? void 0 : _type$vehicle_type.name) + " ")]);
          }), 0), _c('td', {
            attrs: {
              "align": "center"
            }
          }, [item.active ? _c('span', {
            staticClass: "badge badge-primary"
          }, [_vm._v(" Active ")]) : _c('span', {
            staticClass: "badge badge-danger"
          }, [_vm._v("In Active")])]), _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('b-dropdown', {
            attrs: {
              "size": "sm",
              "variant": "outline-primary",
              "text": "Action",
              "right": ""
            }
          }, [_c('b-dropdown-item', {
            on: {
              "click": function click($event) {
                $event.preventDefault();
                return _vm.openSidebar(item);
              }
            }
          }, [_vm._v(" Edit ")]), _c('b-dropdown-item', {
            staticClass: "text-danger",
            on: {
              "click": function click($event) {
                $event.preventDefault();
                return _vm.deleteItem(item);
              }
            }
          }, [_vm._v(" Delete ")])], 1)], 1)]);
        }), 0)]), _c('div', {
          staticClass: "mt-4 d-flex align-items-center w-100 justify-content-end"
        }, [_c('b-pagination', {
          staticClass: "mb-0 mr-3",
          attrs: {
            "total-rows": _vm.equipment.params.total,
            "per-page": _vm.equipment.params.limit,
            "first-number": "",
            "align": "center"
          },
          on: {
            "input": _vm.fetchData
          },
          model: {
            value: _vm.equipment.params.page,
            callback: function callback($$v) {
              _vm.$set(_vm.equipment.params, "page", $$v);
            },
            expression: "equipment.params.page"
          }
        }), _c('b-form-select', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "plain": "",
            "options": _vm.limitOptions
          },
          on: {
            "input": function input() {
              return _vm.fetchData();
            }
          },
          model: {
            value: _vm.equipment.params.limit,
            callback: function callback($$v) {
              _vm.$set(_vm.equipment.params, "limit", $$v);
            },
            expression: "equipment.params.limit"
          }
        })], 1)])];
      },
      proxy: true
    }])
  })], 1), _c('custom-sidebar', {
    attrs: {
      "size": "lg",
      "title": "".concat(_vm.equipment.editMode ? 'Edit' : 'New', " Equipment")
    },
    model: {
      value: _vm.showSidebar,
      callback: function callback($$v) {
        _vm.showSidebar = $$v;
      },
      expression: "showSidebar"
    }
  }, [_c('b-form', {
    staticClass: "p-4 bg-white",
    staticStyle: {
      "border-radius": "10px"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Equipment Name *",
      "label-for": "project_location"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Equipment Name",
      "required": ""
    },
    model: {
      value: _vm.equipment.form.equipment_name,
      callback: function callback($$v) {
        _vm.$set(_vm.equipment.form, "equipment_name", $$v);
      },
      expression: "equipment.form.equipment_name"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Equipment Code *",
      "label-for": "project_location"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Equipment Code",
      "required": ""
    },
    model: {
      value: _vm.equipment.form.equipment_id,
      callback: function callback($$v) {
        _vm.$set(_vm.equipment.form, "equipment_id", $$v);
      },
      expression: "equipment.form.equipment_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Used For *",
      "label-for": "fleet"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "fleet",
      "multiple": "",
      "placeholder": "Select Vehicle Type",
      "label": "name",
      "options": _vm.typeFleet,
      "reduce": function reduce(opt) {
        return opt.code;
      }
    },
    model: {
      value: _vm.equipment.form.vehicle_type_ids,
      callback: function callback($$v) {
        _vm.$set(_vm.equipment.form, "vehicle_type_ids", $$v);
      },
      expression: "equipment.form.vehicle_type_ids"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Description",
      "label-for": "Description"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "notes",
      "rows": "3",
      "placeholder": "Description"
    },
    model: {
      value: _vm.equipment.form.description,
      callback: function callback($$v) {
        _vm.$set(_vm.equipment.form, "description", $$v);
      },
      expression: "equipment.form.description"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Equipment Category *",
      "label-for": "equipment_category"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "component_name",
      "placeholder": "Select Equipment Category",
      "options": _vm.categoryOpt,
      "reduce": function reduce(opt) {
        return opt.id;
      }
    },
    model: {
      value: _vm.equipment.form.maintenance_component_id,
      callback: function callback($$v) {
        _vm.$set(_vm.equipment.form, "maintenance_component_id", $$v);
      },
      expression: "equipment.form.maintenance_component_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Status *",
      "label-for": "active"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "check-button",
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.equipment.form.active,
      callback: function callback($$v) {
        _vm.$set(_vm.equipment.form, "active", $$v);
      },
      expression: "equipment.form.active"
    }
  }, [_vm.equipment.form.active === false ? [_vm._v("No")] : [_vm._v("Yes")]], 2)], 1), _c('hr'), _c('div', {
    staticClass: "d-flex"
  }, [_c('b-button', {
    staticClass: "mr-3 w-50",
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.closeSidebar
    }
  }, [_vm._v(" Cancel ")]), _c('b-button', {
    staticClass: "w-50",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" " + _vm._s(_vm.equipment.editMode ? 'Save' : 'Add') + " ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }